import DialogInfoField from "./DialogInfoField";
export default DialogInfoField;
export { default as DialogInfoField } from './DialogInfoField';